// Full-page links and public assets must respect the deployed subpath.
export const APP_BASE = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");
export const appUrl = (pathname) => {
  if (!pathname.startsWith("/") || pathname.startsWith("//")) return pathname;
  if (APP_BASE && (pathname === APP_BASE || pathname.startsWith(APP_BASE + "/"))) return pathname;
  return APP_BASE + pathname;
};
